import {
  GET_DATA_PROVIDER_CREDENTIAL_REQUEST,
  GET_DATA_PROVIDER_CREDENTIAL_SUCCESS,
  GET_DATA_PROVIDER_CREDENTIAL_ERROR,
  CREATE_DATA_PROVIDER_CREDENTIAL_REQUEST,
  CREATE_DATA_PROVIDER_CREDENTIAL_SUCCESS,
  CREATE_DATA_PROVIDER_CREDENTIAL_ERROR,
  DELETE_DATA_PROVIDER_CREDENTIAL_REQUEST,
  DELETE_DATA_PROVIDER_CREDENTIAL_SUCCESS,
  DELETE_DATA_PROVIDER_CREDENTIAL_ERROR
} from "../actions/data_provider_credentials";

const defaultState = {
  isFetching: false,
  fetchedAt: null,
  error: null,
  data: null
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_DATA_PROVIDER_CREDENTIAL_REQUEST: {
      return {
        ...state,
        isFetching: true
      };
    }

    case GET_DATA_PROVIDER_CREDENTIAL_SUCCESS: {
      const { data: { credentials, credential_keys } } = action;

      return {
        ...state,
        isFetching: false,
        fetchedAt: new Date(),
        error: null,
        data: {
          ...state.data,
          credentials,
          credential_keys
        }
      };
    }

    case GET_DATA_PROVIDER_CREDENTIAL_ERROR: {
      const { error } = action;

      return {
        ...state,
        isFetching: false,
        error
      };
    }

    case CREATE_DATA_PROVIDER_CREDENTIAL_REQUEST: {
      return {
        ...state,
        isFetching: true
      };
    }

    case CREATE_DATA_PROVIDER_CREDENTIAL_SUCCESS: {
      const { data: newDataProviderCredential } = action;

      return {
        ...state,
        isFetching: false,
        fetchedAt: new Date(),
        error: null,
        data: {
          ...state.data,
          credentials: [newDataProviderCredential, ...state.data.credentials]
        }
      };
    }

    case CREATE_DATA_PROVIDER_CREDENTIAL_ERROR: {
      const { error } = action;

      return {
        ...state,
        isFetching: false,
        error
      };
    }

    case DELETE_DATA_PROVIDER_CREDENTIAL_REQUEST: {
      return {
        ...state,
        isFetching: true
      };
    }

    case DELETE_DATA_PROVIDER_CREDENTIAL_SUCCESS: {
      const { data: deletedDataProviderCredential } = action;

      return {
        ...state,
        isFetching: false,
        fetchedAt: new Date(),
        error: null,
        data: {
          ...state.data,
          credentials: state.data.credentials.filter(key => key.id !== deletedDataProviderCredential.id)
        }
      };
    }

    case DELETE_DATA_PROVIDER_CREDENTIAL_ERROR: {
      const { error } = action;

      return {
        ...state,
        isFetching: false,
        error
      };
    }

    default: return state;
  }
};
